import { render, staticRenderFns } from "./FileWizard.vue?vue&type=template&id=ebcbc64a&"
import script from "./FileWizard.vue?vue&type=script&lang=js&"
export * from "./FileWizard.vue?vue&type=script&lang=js&"
import style0 from "./FileWizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebcbc64a')) {
      api.createRecord('ebcbc64a', component.options)
    } else {
      api.reload('ebcbc64a', component.options)
    }
    module.hot.accept("./FileWizard.vue?vue&type=template&id=ebcbc64a&", function () {
      api.rerender('ebcbc64a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/wizardFlow/FileWizard.vue"
export default component.exports